import React, { Component, Fragment } from 'react'
import api from '../../../utils/api'
import ConstituencyAlert from './constituencyAlert'
import { Typeahead } from 'react-bootstrap-typeahead'
import warningLogo from '../../../utils/images/warningLogo.png'

export default class ShaktiKendra extends Component {
  constructor(props) {
    super(props)

    if (this.props.data !== undefined) {
      this.state = {
        name: this.props.data.data.meta.name,
        mandal: this.props.data.data.meta.mandal,
        updateConstData: true,
      }
    } else {
      this.state = {
        name: '',
        mandal: '',
        updateConstData: false,
      }
    }
  }

  mandal = []
  showWarning = false

  componentDidMount() {
    api
      .getConstituencyData({
        type: 'Mandal Level',
        limit: '10000',
        offset: '0',
        status: true,
      })
      .then((response) => {
        if (response.ok) {
          if (response.data.data === undefined) {
            this.showWarning = true
          } else {
            response.data.data.rows.map((wonderer) =>
              this.mandal.includes(wonderer.meta.name)
                ? null
                : this.mandal.push(wonderer.meta.name)
            )
          }
        }
      })
  }

  showConfirmBox = false

  render() {
    return (
      <Fragment>
        {this.showWarning ? (
          <div className="warningMsg">
            <div className="warningHead">
              <img className="warningLogo" src={warningLogo} alt=""></img>
              <p>Warning</p>
            </div>
            <p className="warningTxt">Please Make atleast one Mandal</p>
          </div>
        ) : (
          <Fragment>
            <form
              onSubmit={(e) => {
                this.props.getConstituencyData(e, this.state)
                this.setState({
                  name: '',
                  mandal: '',
                  updateConstData: false,
                })
              }}
            >
              <div className="TxtInputFrame">
                <p className="TxtInput">Shakti Kendra</p>
                <p className="TxtStar">*</p>
              </div>
              <input
                type="text"
                className="InputFrame"
                placeholder="Please enter Shakti Kendra"
                onChange={(e) => this.setState({ name: e.target.value })}
                value={this.state.name}
                required
              />

              <div className="TxtInputFrame">
                <p className="TxtInput">Mandal</p>
                <p className="TxtStar">*</p>
              </div>
              <Typeahead
                id="mandal"
                labelKey="mandal"
                placeholder="Please select a Mandal"
                onChange={(mandal) => this.setState({ mandal: mandal[0] })}
                options={this.mandal}
                defaultInputValue={this.state.mandal}
              />

              {this.state.updateConstData ? (
                <input
                  type="submit"
                  value="Update"
                  className="BtnSubmit"
                  onClick={() => {
                    console.log('Enters Function')
                    this.showConfirmBox = true
                  }}
                />
              ) : (
                <input
                  type="submit"
                  value="Submit"
                  className="BtnSubmit"
                  onClick={() => {
                    console.log('Enters Function')
                    this.showConfirmBox = true
                  }}
                />
              )}
            </form>
          </Fragment>
        )}
      </Fragment>
    )
  }
}
